import useTypedTranslation from '@/hooks/useTypedTranslation';
import { IndexV2Enum } from '@/types/translations/IndexV2Enum';
import uiItems from '@/constants/ui-items/indexItems.constants';
import IndexNavCommon from './IndexNavCommon';
import { IndexNavNewProps } from '@/types';
import { IndexNavItem } from '@/types/constants/types';
import { IndexNavItemChildrenTypeEnum } from '@/types/constants/enums';
import { useMemo } from 'react';

export function IndexNavAll() {
  const { translate } = useTypedTranslation<IndexV2Enum>('index-v2');

  return (
    <IndexNavCommon
      label={translate(IndexV2Enum['home_nav.all'])}
      items={uiItems.indexNavItems.indexNavItemsAll}
    />
  );
}

export function IndexNavBrands() {
  const { translate } = useTypedTranslation<IndexV2Enum>('index-v2');

  return (
    <IndexNavCommon
      label={translate(IndexV2Enum['home_nav.brand'])}
      items={uiItems.indexNavItems.indexNavItemsBrands}
    />
  );
}

export function IndexNavNew({ newSkus, newCollections }: IndexNavNewProps) {
  const { translate } = useTypedTranslation<IndexV2Enum>('index-v2');

  const newSkusItems: IndexNavItem[] = useMemo(
    () => [
      {
        label: IndexV2Enum['home_nav.new_bottles'],
        children: newSkus.map(sku => ({
          label: sku.name,
          href: sku.href,
          type: IndexNavItemChildrenTypeEnum.notranslate,
        })),
      },
    ],
    [newSkus]
  );

  const newCollectionsItems: IndexNavItem[] = useMemo(
    () => [
      {
        label: IndexV2Enum['home_nav.new_collections'],
        children: newCollections.map(collection => ({
          label: collection.name,
          href: collection.href,
          type: IndexNavItemChildrenTypeEnum.notranslate,
        })),
      },
    ],
    [newCollections]
  );
  return (
    <IndexNavCommon
      label={translate(IndexV2Enum['home_nav.new'])}
      items={[...newSkusItems, ...newCollectionsItems]}
    />
  );
}

export function IndexNavCountries() {
  const { translate } = useTypedTranslation<IndexV2Enum>('index-v2');

  return (
    <IndexNavCommon
      label={translate(IndexV2Enum['home_nav.countries'])}
      items={uiItems.indexNavItems.indexNavItemsCountries}
    />
  );
}

export function IndexNavAbout() {
  const { translate } = useTypedTranslation<IndexV2Enum>('index-v2');

  return (
    <IndexNavCommon
      label={translate(IndexV2Enum['home_nav.about_spiritory'])}
      items={uiItems.indexNavItems.indexNavItemsAbout}
    />
  );
}

export function IndexNavSellOnSpiritory() {
  const { translate } = useTypedTranslation<IndexV2Enum>('index-v2');

  return (
    <IndexNavCommon
      label={translate(IndexV2Enum['home_nav.sell_on_spiritory'])}
      items={uiItems.indexNavItems.indexNavItemsSellOnSpiritory}
    />
  );
}
